module.exports = __webpack_public_path__ + "media/claim/assets/images/right_panel/hand_with_coins_200-9ca482ee00b779e8302ebc9a291ffe81.png";